import * as React from "react";
/**
 * The icon representing a Word file
 */ export const WordFile = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.5 22H21.5C21.775 22 22 21.775 22 21.5V7H18.5C17.673 7 17 6.327 17 5.5V2H7.5C7.225 2 7 2.225 7 2.5V21.5C7 21.775 7.225 22 7.5 22Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M21.293 6.00003L18 2.70703V5.50003C18 5.77503 18.225 6.00003 18.5 6.00003H21.293Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.67",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.56 5.854L18.146 1.439C17.8642 1.15891 17.4833 1.00117 17.086 1H7.5C6.673 1 6 1.673 6 2.5V21.5C6 22.327 6.673 23 7.5 23H21.5C22.327 23 23 22.327 23 21.5V6.914C23 6.514 22.844 6.137 22.56 5.854ZM18 2.707L21.293 6H18.5C18.2241 5.99945 18.0006 5.77591 18 5.5V2.707ZM7.5 22H21.5C21.775 22 22 21.775 22 21.5V7H18.5C17.673 7 17 6.327 17 5.5V2H7.5C7.225 2 7 2.225 7 2.5V21.5C7.00055 21.7759 7.22409 21.9995 7.5 22Z",
        fill: "#605E5C"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.5 14H14V15H19.5C19.7761 15 20 14.7761 20 14.5C20 14.2239 19.7761 14 19.5 14Z",
        fill: "#185ABD"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.5 12H14V13H19.5C19.7761 13 20 12.7761 20 12.5C20 12.2239 19.7761 12 19.5 12Z",
        fill: "#2B7CD3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.5 10H14V11H19.5C19.7761 11 20 10.7761 20 10.5C20 10.2239 19.7761 10 19.5 10Z",
        fill: "#41A5EE"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2 19H12C12.5523 19 13 18.5523 13 18V8C13 7.44772 12.5523 7 12 7H2C1.44772 7 1 7.44772 1 8V18C1 18.5523 1.44772 19 2 19Z",
        fill: "#185ABD"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11 10L9.493 16H8.083C8.083 16 7.062 11.747 7.051 11.5L5.968 16H4.498L3 10H4.386L5.295 14.714L6.452 10H7.792L8.842 14.714C8.858 14.714 9.722 10 9.722 10H11Z",
        fill: "white"
    }));
